var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table-responsive", style: _vm.wrapperStyle },
    [
      _c("table", { staticClass: "table trips-table", class: _vm.tableClass }, [
        _c("thead", { staticClass: "thead-light" }, [
          _c(
            "tr",
            [
              _vm._l(_vm.columns, function (column, index) {
                return (
                  typeof column.show === "function"
                    ? column.show()
                    : column.show !== false
                )
                  ? _c("th", { key: index, attrs: { scope: "col" } }, [
                      _vm._v(
                        "\n          " + _vm._s(column.label) + "\n        "
                      ),
                    ])
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.hasActions
                ? _c(
                    "th",
                    {
                      class: { "has-actions": _vm.hasActions },
                      attrs: { scope: "col" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.Lang.get("messages.actions")) +
                          "\n        "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
        ]),
        _vm._v(" "),
        _c(
          "tbody",
          [
            _vm.loading
              ? _vm._l(5, function (n) {
                  return _c(
                    "tr",
                    { key: "shimmer-" + n, staticClass: "shimmer-row" },
                    [
                      _vm._l(_vm.columns, function (column, index) {
                        return (
                          typeof column.show === "function"
                            ? column.show()
                            : column.show !== false
                        )
                          ? _c("td", { key: index }, [
                              _c("div", { staticClass: "shimmer-box" }),
                            ])
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm.hasActions
                        ? _c("td", [
                            _c("div", {
                              staticClass: "shimmer-box",
                              staticStyle: { width: "80px" },
                            }),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                })
              : [
                  !_vm.items || _vm.items.length === 0
                    ? _c("tr", { staticClass: "table-secondary" }, [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: {
                              colspan:
                                _vm.columns.length + (_vm.hasActions ? 1 : 0),
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.emptyMessage ||
                                    _vm.Lang.get("messages.no_results")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.items, function (item, index) {
                    return _c(
                      "tr",
                      {
                        key: item[_vm.rowKey] || index,
                        class: _vm.getRowClasses(item),
                      },
                      [
                        _vm._l(_vm.columns, function (column, colIndex) {
                          return (
                            typeof column.show === "function"
                              ? column.show(item)
                              : column.show !== false
                          )
                            ? _c(
                                "td",
                                {
                                  key: colIndex,
                                  class: column.tdClass,
                                  style: column.tdStyle,
                                },
                                [
                                  column.key === "#"
                                    ? [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(index + 1) +
                                            "\n            "
                                        ),
                                      ]
                                    : _vm.$scopedSlots[`column-${column.key}`]
                                    ? [
                                        _vm._t(`column-${column.key}`, null, {
                                          item: item,
                                          value: item[column.key],
                                        }),
                                      ]
                                    : _vm.$scopedSlots[column.key]
                                    ? [
                                        _vm._t(column.key, null, {
                                          item: item,
                                          value: item[column.key],
                                        }),
                                      ]
                                    : [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(item[column.key]) +
                                            "\n            "
                                        ),
                                      ],
                                ],
                                2
                              )
                            : _vm._e()
                        }),
                        _vm._v(" "),
                        _vm.hasActions
                          ? _c("td", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "actions-wrapper d-flex align-items-center flex-wrap",
                                },
                                [
                                  _vm._t("actions", null, {
                                    item: item,
                                    buttonClass: _vm.buttonClass,
                                    buttonIcons: _vm.buttonIcons,
                                  }),
                                  _vm._v(" "),
                                  _vm._t("dropdown", null, { item: item }),
                                ],
                                2
                              ),
                            ])
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _vm.$slots.footer || _vm.$scopedSlots.footer
          ? _c("tfoot", [_vm._t("footer")], 2)
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }